<!--<template>-->
<!--    <ul class="menu menu_sub menu_sub-settings navigation__menu-sub">-->
<!--        <template v-if="this.mySetting">-->
<!--            -->
<!--            <li class="menu__item ui-switcher" v-if="showButton && showNotificationButton">-->
<!--            -->
<!--                <span class="ui-switcher__title">Notification</span>-->
<!--                <i class="icon icon_bell" v-if="onSubscribeNotification"></i>-->
<!--                <i class="icon icon_bell-red" v-else></i>-->
<!--                <label class="ui-switcher__box" title="Enable notification">-->
<!--                    <input type="checkbox" :checked="onSubscribeNotification" :class="{'is-disabled': disabledNotification}"-->
<!--                           ref="checkboxPushNotify" :disabled="disabledNotification" @change="clickPushNotification">-->
<!--                    <span class="ui-switcher__label"></span>-->
<!--                </label>-->
<!--            </li>-->
<!--            <li class="menu__item ui-switcher" v-if="this.currentUser.email_verified">-->
<!--                <template v-if="this.mySetting.is_notifications">-->
<!--                    <span class="ui-switcher__title">Subscribed</span>-->
<!--                    <i class="icon icon_subscribe"></i>-->
<!--                </template>-->
<!--                <template v-else>-->
<!--                    <span class="ui-switcher__title">Unsubscribed</span>-->
<!--                    <i class="icon icon_subscribe-on"></i>-->
<!--                </template>-->

<!--                <label class="ui-switcher__box" title="Enable subscribe">-->
<!--                    <input type="checkbox" :checked="this.mySetting.is_notifications" :class="{'is-disabled': disabledButton}"-->
<!--                           ref="checkboxMailNotify" :disabled="disabledButton" @change="subscribeEmailNotifications(!mySetting.is_notifications)">-->
<!--                    <span class="ui-switcher__label"></span>-->
<!--                </label>-->
<!--            </li>-->
<!--            <li class="menu__item ui-switcher" style="cursor: pointer" @click.prevent="changeEmail" v-else>-->
<!--                <span class="ui-switcher__title">Change Email</span>-->
<!--                <i class="icon icon_envelope"></i>-->
<!--            </li>-->
<!--        </template>-->
<!--    </ul>-->
<!--</template>-->

<template>

    <ul class="menu menu_sub menu_sub-settings navigation__menu-sub">
        <template v-if="this.mySetting">
            <!--            <button class="btn btn-warning" @click.prevent="startNotification" :disabled="disabledButton">Notification</button>-->
            <!--            v-if="showNotificationButton"-->
            <li class="menu__item ui-switcher" v-if="showButtonNotification || (isIOSDeviceBrowser && !isIOSDeviceNative)">
                <i class="icon icon_bell" v-if="onSubscribeNotification"></i>
                <i class="icon icon_bell-off" v-else></i>

                <span class="ui-switcher__title">Notification</span>
                <label class="ui-switcher__box" title="Enable notification">
                    <input type="checkbox" :checked="onSubscribeNotification" :class="{'is-disabled': disabledNotification}" :disabled="disabledNotification"
                           ref="checkboxPushNotify"  @change="clickPushNotification">
                    <span class="ui-switcher__label"></span>
                </label>
            </li>
            <li class="menu__item ui-switcher" v-if="this.currentUser.email_verified">
                <template v-if="this.mySetting.is_notifications">
                    <i class="icon icon_subscribe"></i>
                    <span class="ui-switcher__title">Subscribed</span>
                </template>
                <template v-else>
                    <i class="icon icon_subscribe-on"></i>
                    <span class="ui-switcher__title">Unsubscribed</span>
                </template>

                <label class="ui-switcher__box" title="Enable subscribe">
                    <input type="checkbox" :checked="this.mySetting.is_notifications" :class="{'is-disabled': disabledButton}"
                           ref="checkboxMailNotify" :disabled="disabledButton" @change="subscribeEmailNotifications(!mySetting.is_notifications)">
                    <span class="ui-switcher__label"></span>
                </label>
            </li>
            <li class="menu__item ui-switcher" style="cursor: pointer" @click.prevent="changeEmail" v-else>
                <i class="icon icon_envelope"></i>
                <span class="ui-switcher__title">Change Email</span>
            </li>
        </template>
    </ul>
</template>


<script>

// import * as PusherPushNotifications from '@pusher/push-notifications-web'

export default {
    name: "PushNotification",
    props:[
        'currentUser',
        'myUrl',
        'mySetting',
        'onSubscribeNotification',
        'disabledNotification',
        'isIOSDeviceBrowser',
        'isIOSDeviceNative',
        //'showNotificationButton'
    ],
    data(){
        return{
            disabledButton:false,
            showButtonNotification: true,
        }
    },
    computed:{
        // textButton(){
        //     if (Notification.permission === "granted") {
        //         return 'Unsubscribe from notifications'
        //     } else if (Notification.permission === "blocked") {
        //         return 'Renew subscription'
        //     } else {
        //         return 'Subscribe to notifications'
        //     }
        // },
        showButton(){
            return ('Notification' in window && navigator.serviceWorker && 'BeamsClient' in window)
        },
    },
    mounted() {
        this.showButtonNotification = ('Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window)
        console.log({isIOSDeviceBrowser: this.isIOSDeviceBrowser})
        this.$bus.$on('cancel_unsubscribe_notify',this.cancelUnsubscribeNotify);
        this.$bus.$on('off_checkbox_notify',this.offCheckboxNotify);

    },
    beforeDestroy(){
        this.$bus.$off('cancel_unsubscribe_notify',this.cancelUnsubscribeNotify);
        this.$bus.$off('off_checkbox_notify',this.offCheckboxNotify);
    },
    methods:{
        changeEmail(){
            if(this.isPromoPage())return
            console.log('validateEmail');
            this.$bus.$emit('open_modal_change_email');
        },
        cancelUnsubscribeNotify(){
            if(this.isPromoPage())return
            this.$refs.checkboxPushNotify.checked = true;
        },
        validateEmail(){
            if(this.isPromoPage())return
            console.log('validateEmail');
            this.$bus.$emit('show_modal_valid_email');
        },
        subscribeEmailNotifications(status){
            if(this.isPromoPage())return
            console.log('subscribeEmailNotifications',status);
            if (this.mySetting && !this.disabledButton){
                this.disabledButton = true;
                axios.post(`/subscribe-notifications`,{
                    status:status,
                    settingID:this.mySetting.id
                })
                    .then(response => {
                        this.disabledButton = false;
                        console.log(response.data);
                        this.$bus.$emit('change_setting',response.data.settings)
                    })
                    .catch(e => {
                        this.disabledButton = false;
                        console.log(e);
                        this.errorHandler(e);
                    })
            }

        },
        clickPushNotification(){
            try {
                console.log('clickPushNotification');
                if(this.onSubscribeNotification) {
                    this.$bus.$emit('stop_push_notifications');
                    return;
                }
                if('Notification' in window){
                    if(window.Notification.permission === "granted"){
                        localStorage.removeItem('subscription_push_permission_state')
                        this.$bus.$emit('start_push_notifications', true);
                    }else if (Notification.permission !== "denied"){
                        Notification.requestPermission()
                            .then((permission) => {
                                if (permission === "granted") {
                                    localStorage.removeItem('subscription_push_permission_state')
                                    this.$bus.$emit('start_push_notifications_handle');
                                }else {
                                    console.log('Notification.permission user not allowed');
                                    this.offCheckboxNotify()
                                    this.$bus.$emit('show_modal_notify_blocked');
                                }
                            })
                            .catch(err => {
                                console.error(err);
                                this.offCheckboxNotify()
                                this.$bus.$emit('show_modal_notify_blocked');
                            });
                    }else {
                        this.offCheckboxNotify()
                        this.$bus.$emit('show_modal_notify_blocked');
                    }

                    return;
                }
                if(this.isIOSDeviceBrowser && !this.isIOSDeviceNative){
                    this.offCheckboxNotify()
                    this.$bus.$emit('show_modal_notify_ios');
                }

            }catch (e) {
                this.offCheckboxNotify()
                console.error(e)
            }
        },
        offCheckboxNotify(){
            if(this.$refs.checkboxPushNotify) this.$refs.checkboxPushNotify.checked = false;
        },

        showModal() {
            if(this.isPromoPage())return
            this.$bus.$emit('show_modal_notify');
        },
        errorHandler(e){
            this.$emit('errorhandler',e);
        },
        isPromoPage(){
            if(this.$route.name === 'promoProfile' || this.$route.name === 'promoChat'){
                this.$bus.$emit('open_register')
                return true
            }else {return false}
        }
    }
}
</script>

<style scoped>

</style>
